import { ApexOptions } from 'apexcharts';

import { TrapType } from 'components/AnalyticsPage/TrapType';
import { TFunction } from 'i18next';

interface ChartData {
  date: string[];
  mct_total_pests?: number[];
  mct_total_online_traps?: number[];
  smst_total_pests?: number[];
  smst_total_online_traps?: number[];
  srst_total_pests?: number[];
  srst_total_online_traps?: number[];
}

interface SeriesData {
  name: string;
  data: number[];
}

export const trapActivityLineChartOptions = (
  chartData: ChartData,
  t: TFunction,
  trapType: TrapType,
  isMobile: boolean,
) => {
  const series: SeriesData[] = [];

  if (trapType === TrapType.MCT) {
    series.push(
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_1_mct'),
        data: chartData.mct_total_pests || [],
      },
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_2_mct'),
        data: chartData.mct_total_online_traps || [],
      },
    );
  } else if (trapType === TrapType.SMST) {
    series.push(
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_1_smst'),
        data: chartData.smst_total_pests || [],
      },
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_2_smst'),
        data: chartData.smst_total_online_traps || [],
      },
    );
  } else if (trapType === TrapType.SRST) {
    series.push(
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_1_srst'),
        data: chartData.srst_total_pests || [],
      },
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_2_srst'),
        data: chartData.srst_total_online_traps || [],
      },
    );
  } else {
    series.push(
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_1_mct'),
        data: chartData.mct_total_pests || [],
      },
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_2_mct'),
        data: chartData.mct_total_online_traps || [],
      },
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_1_smst'),
        data: chartData.smst_total_pests || [],
      },
      {
        name: t('ChartsAnalitics.traps_vs_cought_mice_chart.name_2_smst'),
        data: chartData.smst_total_online_traps || [],
      },
    );
  }

  const chartOptions: ApexOptions = {
    series: series,
    chart: {
      height: 350,
      type: 'area',
      zoom: {
        enabled: !isMobile,
      },
      toolbar: {
        show: true,
      },
    },
    markers: {
      size: 3,
      shape: 'circle',
    },
    title: {
      align: 'left',
    },
    stroke: {
      width: [3, 3],
      curve: ['smooth', 'stepline', 'smooth', 'stepline'],
    },
    xaxis: {
      categories: chartData.date || [],
      type: 'category',
      tickPlacement: 'on',
      title: {
        text: t('ChartsAnalitics.traps_vs_cought_mice_chart.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      title: {
        text: t('ChartsAnalitics.traps_vs_cought_mice_chart.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      floating: false,
      fontSize: '10px',
      fontWeight: 'bold',
      labels: {
        colors: '#000',
      },
    },
    colors: ['#6A37D4', '#FFE529', '#0ab39c', '#94C748'],
  };

  return chartOptions;
};
